module.exports = __webpack_public_path__ + "static/media/water-terrein.9a229460.png";